import { defineAsyncComponent } from 'vue'
export default {
  blank: defineAsyncComponent(() => import("/app/app/layouts/blank.vue").then(m => m.default || m)),
  page: defineAsyncComponent(() => import("/app/app/layouts/page.vue").then(m => m.default || m))
}